export default "__VITE_ASSET__e3b9f0df__"